import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import { getSrc } from 'gatsby-plugin-image'
import { isNilOrEmpty } from 'ramdasauce'

export const Seo = ({ meta, title, pageDesc, pageImage }) => {
  const data = useStaticQuery(detailsQuery)

  const sanityData = data.sanitySeoContent
  const roughSeoImage = getSrc(sanityData?.seoImage?.asset)
  const formattedSeoImage = 'https:' + roughSeoImage
  const seoImage = pageImage || formattedSeoImage
  const metaDescription = pageDesc || sanityData?.description

  return (
    <>
      <title>{`${title} | ${data.site.siteMetadata.title}`}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={data.site.siteMetadata.author} />
      <meta name="twitter:creator" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta property="og:title" content={seoImage} />
      <meta property="og:image:width" content={1200} />
      <meta property="og:image:height" content={630} />
    </>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
}

Seo.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
    sanitySeoContent {
      description
      seoImage {
        asset {
          gatsbyImageData
        }
      }
    }
  }
`
